import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ImageDataDb } from '../_shared/data/image-data-db.data';
import { LinkDirective } from '../_shared/directives';
import { ImageData, IProductInformation } from '../_shared/models';
import { ProductLayout } from '../_shared/types';
import { ButtonComponent } from '../button/button.component';
import { ChipComponent } from '../chip/chip.component';
import { HeadingComponent } from '../heading/heading.component';
import { ImageItemComponent } from '../media/media-item/image-item/image-item.component';

@Component({
    selector: 'sirius-product-information',
    imports: [ButtonComponent, ImageItemComponent, HeadingComponent, ChipComponent, LinkDirective],
    templateUrl: './product-information.component.html',
    styleUrl: './product-information.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.sir-product]': 'layout === "product"',
        '[class.sir-series]': 'layout === "series"',
    }
})
export class ProductInformationComponent {
    @Input({ required: true }) config!: IProductInformation;
    @Input() layout: ProductLayout = 'product';

    readonly imageData: ImageData = ImageDataDb.productInformation;
}
